<template>
  <div id="error-page" class="registration-page">
    <div class="registration-page-container">
      <div class="message-box">
        <i class="message-icon error-ico" alt="에러 메시지 이미지"></i>
        <p class="message-text">
          죄송합니다.
        </p>
        <div class="section-separator" />

        <div class="group-horizontal">
          <p class="message-text">
            <span class="message-text-small">
              요청하신 URL을 서버에서 찾을 수 없습니다.<br>
              관리자에게 문의 하십시요.
              <!-- <br />ERROR: {{status}} -->
            </span>
          </p>
        </div>
        <div class="section-separator" />
      </div>
      <div class="section">
        <div class="section-body">
          <div class="button-container errorpage input-wrap">
            <button
              type="button"
              class="normal-button input-width-small mw30 ml0"
              @click="close"
            >
              닫기
            </button>
            <!-- <span class="field-group-space"></span>
            <button type="button" class="secondary-button  mw70">
              이전 페이지로 이동
            </button> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFound',
  data() {
    // return {
    //   status: "404"
    // }
  },

  components: {},

  computed: {},

  created() {},

  beforeMount() {},

  mounted() {
    // if (this.$route.params.status) {
    //   this.status = this.$route.params.status
    // }
  },

  methods: {
    /** 
     * Function    : close
     * Description : 닫기버튼 클릭 시 브라우져 닫기
     **/
    close() {
      self.close()
    }
  }
}
</script>

<style scoped></style>
